import { render, staticRenderFns } from "./uiLoader.vue?vue&type=template&id=0910e9ee&scoped=true"
var script = {}
import style0 from "./uiLoader.vue?vue&type=style&index=0&id=0910e9ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910e9ee",
  null
  
)

export default component.exports